import { SurfaceDefect } from "@/shared/models/Inspection";
import { getSurfaceDefects } from "@/shared/repositories/SurfaceDefectRepository";
import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { TableSurfaceDefects } from "./components/TableSurfaceDefects";

export const useSurfaceDefectCatalog = (onError?: (error: Error) => void) =>
	useQuery<SurfaceDefect[], Error>({
		queryKey: ["surface-defects", false],
		queryFn: ({ signal }) =>
			getSurfaceDefects({ includeInactive: false }, signal),
		onError,
	});

export const SurfaceDefectsPage = () => (
	<>
		<HelmetDexteel title="Surface Defects" />
		<TableSurfaceDefects />
	</>
);
